<app-view-item
  *ngIf="disabled"
  [text]="value"
  [borderless]="borderless"
></app-view-item>
<nz-input-group nzSearch [nzAddOnAfter]="searchBtn" nzCompact *ngIf="!disabled">
  <input
    nz-input
    maxlength="20"
    [(ngModel)]="value"
    (ngModelChange)="onModelChange($event)"
  />
  <ng-template #searchBtn>
    <button type="button" nz-button (click)="showModal()" nzSearch
      ><span nz-icon nzType="search"></span
    ></button>
  </ng-template>
</nz-input-group>

<nz-modal
  nzWidth="1200px"
  nzTitle="Delivery Address"
  [nzVisible]="visible"
  (nzOnCancel)="visible = false"
>
  <ng-container *nzModalContent>
    <div class="w-full overflow-x-auto">
      <st
        [data]="data"
        [columns]="columns"
        *ngIf="visible"
        #st
        (change)="change($event)"
        [responsive]="false"
      ></st>
    </div>
  </ng-container>

  <div *nzModalFooter>
    <button type="button" nz-button nzType="default" (click)="clear()">Clear</button>
    <button type="button" nz-button nzType="default" (click)="visible = false">Cancel</button>
    <button type="button" nz-button nzType="primary" (click)="submit()">OK</button>
  </div>
</nz-modal>
